import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useAuth, useMainTradeData } from "@saleor/sdk";
import React from "react";
import { useParams } from "react-router-dom";
import { AlertCallEasyLink } from "@temp/components";
import { EasyLinkLoading } from "../View/EasyLinkLoading";
import { EasyLinkView } from "../View";
export var EasyLinkPage = function EasyLinkPage() {
  var _dataMainTrade$mainTr, _dataMainTrade$mainTr2;

  var _useParams = useParams(),
      slug = _useParams.slug;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      showCall = _React$useState2[0],
      setShowCall = _React$useState2[1];

  var _useAuth = useAuth(),
      isCurrentTokenValid = _useAuth.isCurrentTokenValid,
      signOut = _useAuth.signOut,
      user = _useAuth.user;

  var handleVerifyToken = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _yield$isCurrentToken, isValid;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(user === null || user === void 0 ? void 0 : user.id)) {
                _context.next = 10;
                break;
              }

              window.avoidRefreshSignInToken();
              _context.next = 4;
              return isCurrentTokenValid();

            case 4:
              _yield$isCurrentToken = _context.sent;
              isValid = _yield$isCurrentToken.isValid;

              if (isValid) {
                _context.next = 9;
                break;
              }

              _context.next = 9;
              return signOut();

            case 9:
              window.allowRefreshSignInToken();

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleVerifyToken() {
      return _ref.apply(this, arguments);
    };
  }();

  React.useEffect(function () {
    handleVerifyToken();
  }, []);

  var _useMainTradeData = useMainTradeData({
    slug: slug
  }, {
    fetchPolicy: "network-only"
  }),
      dataMainTrade = _useMainTradeData.data,
      loadingMainTradeData = _useMainTradeData.loading;

  return React.createElement(React.Fragment, null, loadingMainTradeData || dataMainTrade === null || (dataMainTrade === null || dataMainTrade === void 0 ? void 0 : dataMainTrade.mainTradeData) === null ? React.createElement(EasyLinkLoading, {
    loading: loadingMainTradeData,
    data: dataMainTrade
  }) : React.createElement(EasyLinkView, {
    data: dataMainTrade === null || dataMainTrade === void 0 ? void 0 : dataMainTrade.mainTradeData,
    setShowCall: setShowCall
  }), showCall && (dataMainTrade === null || dataMainTrade === void 0 ? void 0 : (_dataMainTrade$mainTr = dataMainTrade.mainTradeData) === null || _dataMainTrade$mainTr === void 0 ? void 0 : _dataMainTrade$mainTr.deliveryPhoneNumber) && React.createElement(AlertCallEasyLink, {
    hideModal: function hideModal() {
      setShowCall(false);
    },
    tradeNumber: dataMainTrade === null || dataMainTrade === void 0 ? void 0 : (_dataMainTrade$mainTr2 = dataMainTrade.mainTradeData) === null || _dataMainTrade$mainTr2 === void 0 ? void 0 : _dataMainTrade$mainTr2.deliveryPhoneNumber
  }));
};